import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const features = [{
  id: 1,
  text: "Customized deep tissue pressure tailored to your muscle tension"
}, {
  id: 2,
  text: "Organic essential oil blends for therapeutic aromatherapy"
}];
export default function CanalLivingContent() {
  return <section data-section-id="260689" id="bodytreatments" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="relative rounded-lg overflow-hidden shadow-xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_massage_therapy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_massage_therapy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_massage_therapy.png-wvc-sizes" alt="Soft focus view of a peaceful massage room with warm lighting" className="w-full h-auto object-cover opacity-90" loading="lazy" />
          </div>

          {}
          <div className="flex flex-col items-start">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-default">
              Restorative Body Treatments
            </h2>
            
            <div className="space-y-4 text-muted-foreground leading-relaxed font-default">
              <p className="!font-sans">We know your body works hard, and sometimes it needs more than a light rubdown to feel right again. Our deep tissue treatments are built for that. Our staff use slow, deliberate pressure and focused technique to get into the muscle and work out the tension that's been building up.</p>
              <p className="!font-sans">
                Our <span className="text-primary font-semibold">Deep Tissue Therapy</span> goes beyond surface-level relaxation, targeting specific trigger points to alleviate pain and restore natural alignment. We enhance every session with high-exposure, soft-focus sensory details—from the gentle scent of forest pine to the warmth of ivory linens. Clients from <span className="text-primary font-semibold">Portland</span> and <span className="text-primary font-semibold">Beaverton</span> seek our sanctuary for its non-clinical, professional atmosphere.
              </p>
              
            </div>

            <ul className="mt-8 space-y-3 w-full">
              {features.map((feature, i) => <li key={feature.id} data-index={i} className="flex items-center gap-2">
                  <Check className="w-4 h-4 text-primary flex-shrink-0" />
                  <span className="text-sm md:text-base text-muted-foreground font-default">
                    {feature.text}
                  </span>
                </li>)}
            </ul>

            <Button asChild size="lg" className="mt-10 bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg shadow-md">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}